import { UserProvider } from 'context/users/userContext';
import UsersComponent from './UsersComponent';
import UserForm from './UserForm';
import DeactivateUserDialog from './table/dialogs/DeactivateUserDialog';

const UsersSection = () => {
    return (
        <UserProvider>
            <UsersComponent />
            <UserForm />
            <DeactivateUserDialog />
        </UserProvider>
    );
};

export default UsersSection;
